module.exports = __webpack_public_path__ + "media/Headervideo2-mp4-50.90d074a6.mp4";